var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightningGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66674 1.33325L2.72904 8.45849C2.4965 8.73753 2.38023 8.87706 2.37846 8.99489C2.37691 9.09733 2.42256 9.19479 2.50224 9.25918C2.5939 9.33325 2.77552 9.33325 3.13876 9.33325H8.00007L7.3334 14.6666L13.2711 7.54135C13.5036 7.2623 13.6199 7.12278 13.6217 7.00494C13.6232 6.90251 13.5776 6.80505 13.4979 6.74066C13.4062 6.66659 13.2246 6.66659 12.8614 6.66659H8.00007L8.66674 1.33325Z",
    stroke: "url(#paint0_linear_1960_194730)",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1960_194730",
    x1: 2.37842,
    y1: 14.6666,
    x2: 15.5203,
    y2: 3.58474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE46BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningGradient);
export default __webpack_public_path__ + "static/media/lightning-gradient.a0e39e5372b476f508564719687e2b0c.svg";
export { ForwardRef as ReactComponent };